import { useForm } from 'react-final-form';

import type { BetSlipMutators } from '../utils/betSlipFormMutators';

export const useFormMutators = () => {
  const { mutators } = useForm<BetSlipMutators>();
  return mutators;
};
